import { Switch, SwitchProps } from "@mui/material";
import withStyles from '@mui/styles/withStyles';
import React, { FunctionComponent, useState } from "react";
import { AppTheme } from "../AppTheme";

/**
 * Switch control properties.
 */
type SwitchControlInput = { offLabel: string | null, onLabel: string | null, onChange?: (checked: boolean) => void, switchProps: SwitchProps };

// create MUI switch component with customised styles
const StyledSwitch = withStyles({
    switchBase: {
        color: AppTheme.palette.primary.main,
        '&.MuiSwitch-switchBase.Mui-checked': {
            color: AppTheme.palette.primary.main,
        },
        '&.MuiSwitch-track': {
            backgroundColor: AppTheme.palette.primary.main,
        },
        '&.MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
            backgroundColor: AppTheme.palette.primary.main,
        },
    },    
    checked: {},
    track: {},
})(Switch);

/**
 * Switch component, like a checkbox but appears like a switch.
 * @param props Configuration properties.
 * @see SwitchControlInput
 * @see Switch
 */
export const SwitchControl: FunctionComponent<SwitchControlInput> = function (props: SwitchControlInput) {
    const [checked, setChecked] = useState(props.switchProps.checked);

	// change handler for the switch control
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {

        if (props.onChange) {

			// call provided on change handler
            props.onChange(checked);
        }

        props.switchProps.checked = checked;

        setChecked(checked);
    };

	// click handler for the off label state
    const labelOffClick = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {

        if (event.currentTarget.classList.contains("switch-off-label") && checked !== false) {

            props.switchProps.checked = false;

            if (props.onChange) {

                props.onChange(false);
            }

            setChecked(false);
        }
    };

	// click handler for the on label state
    const labelOnClick = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {

        if (event.currentTarget.classList.contains("switch-on-label") && checked !== true) {

            props.switchProps.checked = true;

            if (props.onChange) {

                props.onChange(true);
            }

            setChecked(true);
        }
    };

	// create on / off span elements
    const offLabel = props.offLabel ? <span className="switch-off-label" onClick={labelOffClick}>{props.offLabel}</span> : null;
    const onLabel = props.onLabel ? <span className="switch-on-label" onClick={labelOnClick}>{props.onLabel}</span> : null;

	// output styled switch wrapped in a span
	return (
		<span className="switch">
            {offLabel}
            <StyledSwitch
                {...props.switchProps}
                onChange={handleChange}
                />
            {onLabel}
        </span>);
}